import { useNavigate, useParams } from "react-router-dom";
import ReactHelmet from "../../Components/ReactHelmet";
import SidePanel from "../../Components/SidePanel";
import "./Book.css";
import { useEffect, useRef, useState } from "react";
import Styles from "./Book.module.css";
import TopBar from "../../Components/TopBar";
import { BookJson } from "./BookModel";
import HTMLFlipBook from "react-pageflip";
import BookReaderMobile from "./BookReadMobile";
import { useSelector } from "react-redux";
import { Book_Details } from "../../Action/BookDemoAction";
import { useDispatch } from "react-redux";

export default function BookReadDesktop() {
  const [SidebarOpen, SetSideBarOpen] = useState(false);
  const [OpenMenuBar2, setOpenMenuBar2] = useState(false);
  const [BookDetails, setBookDetails] = useState({});
  const [BookPage, setBookPage] = useState({ Book: [], PageNo: 1 });

  const Navigate = useNavigate();
  const dispatch = useDispatch();
  const book = useRef();
  const { bookDet, loading, error } = useSelector(
    (s) => s.Book_Details_Reducer
  );

  const { bookId } = useParams();
  const Mobile_Screen = window.innerWidth;

  function generateArray(start, end, length) {
    let arr = [];
    for (let i = start; i <= end; i++) {
      arr.push(i.toString().padStart(length, "0"));
    }
    return arr;
  }

  useEffect(() => {
    if (bookId) {
      // console.log(
      //   bookId,
      //   BookJson?.find((ev) => ev?.BookName == bookId)
      // );
      setBookDetails(BookJson?.find((ev) => ev?.BookName == bookId));

      const arr = generateArray(
        1,
        BookJson?.find((ev) => ev?.BookName == bookId)?.Pages,
        BookJson?.find((ev) => ev?.BookName == bookId)?.PagesLength?.length
      );

      setBookPage({ Book: arr, PageNo: 1 });
    }
  }, [bookId]);
  useEffect(() => {
    dispatch(Book_Details());
  }, [dispatch]);

  return Mobile_Screen <= 880 ? (
    <BookReaderMobile
      bookId={bookId}
      BookDetails={BookDetails}
      book={book}
      setBookPage={setBookPage}
      BookPage={BookPage}
      bookDet={bookDet}
      loading={loading}
    />
  ) : (
    <>
      <div className={Styles.Dashboard}>
        <ReactHelmet title={"Dashboard"} description={"Student Dashboard"} />
        {/* SidePanel */}
        {Mobile_Screen >= 780 ? (
          <SidePanel
            SetSideBarOpen={SetSideBarOpen}
            SidebarOpen={SidebarOpen}
            SetSideBarOpen2={setOpenMenuBar2}
            SidebarOpen2={OpenMenuBar2}
            Page="Dashboard"
          />
        ) : (
          ""
        )}

        {/* {loadingPack || loading ? <Loading /> : ""} */}

        {/* 
        {EnrollActive ? (
          <Enroll
            setEnrollActive={setEnrollActive}
            Package_Id={EnrollActive}
            courseId={CourseId}
          />
        ) : (
          ""
        )} */}

        {Mobile_Screen <= 480 && SidebarOpen ? (
          <SidePanel
            SetSideBarOpen={SetSideBarOpen}
            SidebarOpen={SidebarOpen}
            Page="Dashboard"
          />
        ) : (
          ""
        )}

        <section className={Styles.MiddleSection}>
          <div style={{ marginTop: "20px" }}>
            <TopBar
              SetSideBarOpen={SetSideBarOpen}
              SidebarOpen={SidebarOpen}
              SetSideBarOpen2={setOpenMenuBar2}
              SidebarOpen2={OpenMenuBar2}
              PageName={"Testifyi Books"}
            />
          </div>
          <div className="Books_Reader">
            {bookDet ? (
              <div id="reader" class="page">
                <header class="reader-header">
                  <button
                    class="back-btn"
                    onClick={() => Navigate("/student/books")}
                  >
                    ←
                  </button>
                  <div class="reader-title">
                    <h2 id="currentBookTitle">
                      {bookId?.replaceAll("-", " ")}
                    </h2>
                    <div class="page-counter">
                      <span id="currentPage">{BookPage?.PageNo}</span> /{" "}
                      <span id="totalPages">{BookDetails?.Pages}</span>
                    </div>
                  </div>
                  <button class="menu-btn-reader">⋮</button>
                </header>

                <div class="reader-container">
                  <div class="page-navigation">
                    <button
                      class="nav-btn prev-btn"
                      onClick={() => book.current.pageFlip().flipPrev()}
                    >
                      ‹
                    </button>
                    <button
                      class="nav-btn next-btn"
                      onClick={() => book.current.pageFlip().flipNext()}
                    >
                      ›
                    </button>
                  </div>

                  <div class="Book-page-pages" id="">
                    <HTMLFlipBook
                      onFlip={(e) => {
                        setBookPage({ ...BookPage, PageNo: e.data + 1 }); // e.data is the current page index
                      }}
                      ref={book}
                      width={500}
                      height={500}
                    >
                      {BookPage?.Book?.map((ev, i) => (
                        <div class="" data-page={i + 1}>
                          <img
                            src={
                              process.env.REACT_APP_DOC +
                              "/Books/" +
                              BookDetails?.Book_Cover?.replace(
                                BookDetails?.PagesLength,
                                ev
                              )
                            }
                            alt={"Page " + (i + 1)}
                            class="page-image"
                          />
                        </div>
                      ))}
                    </HTMLFlipBook>
                  </div>

                  {/* <div class="progress-indicator">
                  <div class="progress-bar">
                    <div class="progress-fill" id="progressFill"></div>
                  </div>
                  <span class="progress-text">Reading Progress</span>
                </div> */}
                </div>
              </div>
            ) : (
              ""
            )}
          </div>
        </section>

        {/* <RightSidePanel
          SetSideBarOpen={setOpenMenuBar2}
          SidebarOpen={OpenMenuBar2}
        />
        <div
          onClick={() => {
            SetSideBarOpen(false);
            setOpenMenuBar2(false);
          }}
          className={SidebarOpen || OpenMenuBar2 ? "overlay active" : "overlay"}
          id="overlay"
        ></div> */}
      </div>
    </>
  );
}
